<template>
    <u-swiper-pagination-text-divider v-bind="$attrs">
        <slot />
    </u-swiper-pagination-text-divider>
</template>

<script>
import USwiperPaginationTextDivider from "@/components/publish/styles/swipers/u-swiper-pagination-text-divider.vue";

export default {
    props: {},
    components: {
        USwiperPaginationTextDivider,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>